import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { IKIOSKModel, IKioskOtherServiceMenu, IkioskTokenType } from "../../../../models/kioskModel2";
import { generateOtherServicesToken_Request } from "../../../../store/actions";
import { Ilanguages } from "../../../../models/utilitiesModel";

const OtherServicesMenu: React.FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("translations");
    const [selectbranch, setSelectbranch] = useState(0);
    const language: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.language || Ilanguages.ENG);
    const menusData: IKioskOtherServiceMenu[] = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.otherServicesMenus || []);
    const otherserviceErrorMessage:string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.otherserviceErrorMessage || undefined);
    const handleSelectbranch = (id: number) => { selectbranch !== id ? setSelectbranch(id) : setSelectbranch(0) }
    console.log("OtherservicesMenus=>>", menusData,otherserviceErrorMessage);
    const [itemOffSet, setItemOffSet] = useState(1)
    const lastIndex=itemOffSet*8
    const fisrstIndex=lastIndex-8
    const pageCount = Math.ceil(menusData.length / 8)
    const currentItem=menusData?.slice(fisrstIndex,lastIndex)

    return (
        <div className='Kiosk_othermenu'>
            <h2>{t('kiosktranslation.Welcome' + language)}</h2>
            {menusData?.length > 0 ? <>
                <span>{t("kiosktranslation.selectOptions" + language)}<br />{t("kiosktranslation.help" + language)}</span>
                <div className="d-flex gap-2">
                    {menusData?.length > 8  &&<button type="button" className='kiosk_previous_btn' disabled={itemOffSet===1} onClick={()=>setItemOffSet((val)=>val-1)}><i className="icon_m42kiosk_left_arrow"></i></button>}
                    <div className='d-flex align-items-start flex-wrap gap-4 my-4 menu-container'>
                        {currentItem?.map((menu, index) => (
                            <div key={index} className={'menu_card pointer ' + (selectbranch === menu.branchId && "selected")} onClick={() => { handleSelectbranch(menu.branchId) }}>{language === Ilanguages.ENG ? menu?.branchNameEn : menu?.branchNameAr}</div>
                        ))}
                    </div>
                   { menusData?.length > 8 &&<button type="button" className='kiosk_next_btn' disabled={itemOffSet === pageCount} onClick={()=>setItemOffSet((val)=>val+1)}><i className="icon_m42kiosk_right_arrow"></i></button>}
                </div>

                {/* <hr style={{color: '#36C0C9'}}/> */}
                {/* <div className="d-flex justify-content-end gap-2">
                    <button type="button" className='kiosk_previous_btn'><i className="icon_m42kiosk_left_arrow"></i></button>
                    <button type="button" className='kiosk_next_btn' disabled>Next <i className="icon_m42kiosk_right_arrow ms-2"></i></button>
                </div> */}
                <button type="button" className='kiosk_generate_btn mx-50' disabled={selectbranch === 0} onClick={() => dispatch(generateOtherServicesToken_Request(IkioskTokenType.OTHERSERVICES, selectbranch))}>{t("kiosktranslation.generate" + language)}</button>
                {otherserviceErrorMessage && <span className="message_response">{otherserviceErrorMessage === 'EM0' ? <p><span>{t('errorMessage.EM1' + language)}<br/>{t('errorMessage.EM2' + language)}</span></p> : otherserviceErrorMessage}</span>}
            </>
                :
                <>
                    {t("kiosktranslation.nootherServiceMenus" + language)}
                </>}
        </div>
    )
}
export default React.memo(OtherServicesMenu);